import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import qs from 'qs';
Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    isLoading: true,
    searchInput: '房東的貓',
    searchType: 'artist',
    token: '',
    kkboxData: '',
    searchItems: '',
    artistID: '',
    code: '',
    accessToken: '',
    activeRouter: '單曲搜尋',
    YTcurrentTrack: '',
    KKcurrentTrack: '',
    YTTrackId: '',
    iframeId: '',
    YTSearchName: ''
  },
  actions: {
    updateLoading(context, payload) {
      context.commit('LOADING', payload);
    },
    getToken(context) {
      const api =
        'https://cors-anywhere.herokuapp.com/https://account.kkbox.com/oauth2/token';
      const config = {
        headers: {
          Accept: 'application/x-www-form-urlencoded',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };
      const oauth = {
        grant_type: 'client_credentials',
        client_id: 'fb254aff20b31017a2e84e34ed896523',
        client_secret: 'd2f7853d7a7e2afd98bc4751f1b3c81a'
      };
      axios.post(api, qs.stringify(oauth), config).then(res => {
        context.commit('TOKEN', res.data.access_token);
        context.dispatch('getSearch');
      });
    },
    getSearch(context) {
      context.commit('LOADING', true);
      context.commit('SEARCHITEMS', '');
      const config = {
        headers: {
          Authorization: ` Bearer ${context.state.token}`
        }
      };
      axios
        .get(
          `https://api.kkbox.com/v1.1/search?q=${context.state.searchInput}&type=${context.state.searchType}&territory=TW`,
          config
        )
        .then(res => {
          context.commit('KKBOXDATA', res.data);
          if (context.state.searchType === 'artist') {
            context.commit(
              'ARTISTID',
              context.state.kkboxData.artists.data[0].id
            );
            axios
              .get(
                `https://api.kkbox.com/v1.1/artists/${context.state.artistID}/top-tracks?territory=TW&limit=20`,
                config
              )
              .then(res => {
                context.commit('SEARCHITEMS', res.data.data);
                context.commit('LOADING', false);
              });
          } else if (context.state.searchType === 'track') {
            axios
              .get(
                `https://api.kkbox.com/v1.1/search?q=${context.state.searchInput}&type=${context.state.searchType}&territory=TW&limit=20`,
                config
              )
              .then(res => {
                // vm.searchItems = res.data.tracks.data;
                context.commit('SEARCHITEMS', res.data.tracks.data);
                // vm.$store.dispatch("updateLoading", false);
                context.commit('LOADING', false);
              });
          }
        });
    },
    getAccessToken(context) {
      if (!context.state.code) {
        return false;
      } else {
        const api =
          'https://cors-anywhere.herokuapp.com/https://account.kkbox.com/oauth2/token';
        const config = {
          headers: {
            Accept: 'application/x-www-form-urlencoded',
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        const oauth = {
          grant_type: 'authorization_code',
          code: context.state.code,
          client_id: 'fb254aff20b31017a2e84e34ed896523',
          client_secret: 'd2f7853d7a7e2afd98bc4751f1b3c81a'
        };
        axios.post(api, qs.stringify(oauth), config).then(res => {
          context.commit('ACCESSTOKEN', res.data.access_token);
        });
      }
    },
    playKkbox(context, item) {
      context.commit('YTCURRENTTRACK', '');
      context.commit('KKCURRENTTRACK', '');
      context.commit('YTTRACKID', '');
      context.commit('IFRAMEID', '');
      context.commit('KKCURRENTTRACK', item.id);
      setTimeout(function() {
        context.commit('IFRAMEID', item.id);
        let KK_iframe_container = document.querySelector(
          '.KK_iframe_container'
        );
        KK_iframe_container.style.opacity = 0.9;
      }, 10);
    },
    playYT(context, item) {
      const vm = this;
      context.commit('YTCURRENTTRACK', '');
      context.commit('KKCURRENTTRACK', '');
      context.commit('YTTRACKID', '');
      context.commit('IFRAMEID', '');
      context.commit('YTSEARCHNAME', '');
      context.commit('YTCURRENTTRACK', item.id);
      setTimeout(function() {
        context.commit('YTSEARCHNAME', item.name);
        let TY_iframe_container = document.querySelector(
          '.TY_iframe_container'
        );
        TY_iframe_container.style.opacity = 0.9;
        axios
          .get(
            `https://www.googleapis.com/youtube/v3/search?key=AIzaSyD5X4wGGRG0IyiFPYt66UXKAg-An0ystvQ&part=snippet&type=video&q=${context.state.YTSearchName}`
          )
          .then(res => {
            context.commit('YTTRACKID', res.data.items[0].id.videoId);
          });
      }, 100);
    }
  },
  mutations: {
    LOADING(state, payload) {
      state.isLoading = payload;
    },
    TOKEN(state, payload) {
      state.token = payload;
    },
    KKBOXDATA(state, payload) {
      state.kkboxData = payload;
    },
    ARTISTID(state, payload) {
      state.artistID = payload;
    },
    SEARCHITEMS(state, payload) {
      state.searchItems = payload;
    },
    SEARCHINPUT(state, payload) {
      state.searchInput = payload;
    },
    SERACHTYPECHANGE(state, payload) {
      state.searchType = payload;
    },
    CODE(state, payload) {
      state.code = payload;
    },
    ACCESSTOKEN(state, payload) {
      state.accessToken = payload;
    },
    ACTIVEROUTER(state, payload) {
      state.activeRouter = payload;
    },
    YTCURRENTTRACK(state, payload) {
      state.YTcurrentTrack = payload;
    },
    KKCURRENTTRACK(state, payload) {
      state.KKcurrentTrack = payload;
    },
    YTTRACKID(state, payload) {
      state.YTTrackId = payload;
    },
    IFRAMEID(state, payload) {
      state.iframeId = payload;
    },
    YTSEARCHNAME(state, payload) {
      state.YTSearchName = payload;
    }
  },
  modules: {}
});
